// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICustomPageable
 */
export interface ICustomPageable {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageable
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageable
     */
    page_number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageable
     */
    page_size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageable
     */
    paged?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageable
     */
    unpaged?: boolean;
}

/**
 * Check if a given object implements the ICustomPageable interface.
 */
export function instanceOfICustomPageable(value: object): value is ICustomPageable {
    return true;
}

export function ICustomPageableFromJSON(json: any): ICustomPageable {
    return ICustomPageableFromJSONTyped(json, false);
}

export function ICustomPageableFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageable {
    if (json == null) {
        return json;
    }
    return {
        
        'offset': json['offset'] == null ? undefined : json['offset'],
        'page_number': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'page_size': json['pageSize'] == null ? undefined : json['pageSize'],
        'paged': json['paged'] == null ? undefined : json['paged'],
        'unpaged': json['unpaged'] == null ? undefined : json['unpaged'],
    };
}

export function ICustomPageableToJSON(json: any): ICustomPageable {
    return ICustomPageableToJSONTyped(json, false);
}

export function ICustomPageableToJSONTyped(value?: ICustomPageable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offset': value['offset'],
        'pageNumber': value['page_number'],
        'pageSize': value['page_size'],
        'paged': value['paged'],
        'unpaged': value['unpaged'],
    };
}

